import React from 'react';
import Header from '../../components/Header/Header';
import Footer from '../../components/Footer/Footer';
import './Opportunities.css';
import serranoImg from '../../assets/images/serrano.jpg';
import granViaImg from '../../assets/images/granvia1.png';
import aragoImg from '../../assets/images/arago1.png';
import serranoPlan from '../../assets/images/serranoPlan.png';
import granViaPlan from '../../assets/images/granviaPlan.png';
import aragoPlan from '../../assets/images/aragoPlan.png';

const opportunitiesData = [
  {
    title: "c/Travessera Corts 136",
    description: "4 meses de operación",
    imgSrc: serranoImg,
    details: {
      area: "84 m²",
      rooms: "3 habitaciones",
      bathrooms: "2 baños",
      utility: "5,25%",
      plan: serranoPlan,
    }
  },
  {
    title: "c/Calàbria 232",
    description: "4 meses de operación",
    imgSrc: granViaImg,
    details: {
      area: "65 m²",
      rooms: "2 habitaciones",
      bathrooms: "1 baño",
      utility: "5,8%",
      plan: granViaPlan,
    }
  },
  {
    title: "c/Aragó 291",
    description: "4 meses de operación",
    imgSrc: aragoImg,
    details: {
      area: "55 m²",
      rooms: "1 habitación",
      bathrooms: "1 baño",
      utility: "6,7%",
      plan: aragoPlan,
    }
  },
];

const Opportunities = () => {
  return (
    <div>
      <Header />
      <div className="opportunities-container">
        <h2 className="section-title">Oportunidades de Inversión</h2>
        {opportunitiesData.map((opportunity, index) => (
          <div className="opportunity-item" key={index}>
            <div className="details-container">
              <h3 className="opportunity-title">{opportunity.title}</h3>
              <p className="opportunity-description">{opportunity.description}</p>
            </div>
            <div className="image-details-container">
              <div className="image-container">
                <img src={opportunity.imgSrc} alt={opportunity.title} className="project-image" />
              </div>
              <div className="image-container">
                <img src={opportunity.details.plan} alt={`Plan de ${opportunity.title}`} className="project-plan" />
              </div>
            </div>
            <div className="details-icons">
              <p><i className="fas fa-ruler-combined"></i> {opportunity.details.area}</p>
              <p><i className="fas fa-bed"></i> {opportunity.details.rooms}</p>
              <p><i className="fas fa-bath"></i> {opportunity.details.bathrooms}</p>
              <p><i className="fas fa-chart-line"></i> Utilidad: {opportunity.details.utility}</p>
            </div>
          </div>
        ))}
      </div>
      <Footer />
    </div>
  );
};

export default Opportunities;
